export default __webpack_public_path__ + "static/media/Niramit-Italic.baa8174e.ttf";